<template lang="html">
  <d-form>
    <d-form-row>
      <!-- Razão Social -->
      <d-col sm="6" class="form-group">
        <label for="name">Razão Social</label>
        <d-form-input
          type="text"
          id="name"
          label="Razão Social"
          v-model="model.name"
          readonly
        />
      </d-col>

      <!-- CNPJ -->
      <d-col sm="4" class="form-group">
        <label for="name">CNPJ</label>
        <d-form-input
          type="text"
          id="name"
          label="CNPJ"
          v-model="model.cnpj"
          readonly
        />
      </d-col>
      <!-- Criado Em -->
      <d-col sm="2" class="form-group">
        <label for="feInputReseller">Criado em</label>
        <d-form-input
          type="text"
          id="feInputReseller"
          v-model="model.created"
          readonly
        />
      </d-col>
    </d-form-row>
    <d-form-row>
      <!-- companyType -->
      <d-col sm="6" xl="4" class="form-group">
        <label for="feCompanyType">Qual o tipo da empresa?</label>
        <d-form-input
          type="text"
          id="feCompanyType"
          v-model="model.companyType"
          readonly
        />
      </d-col>
      <!-- monthlyRevenueAverage -->
      <d-col sm="6" xl="4" class="form-group">
        <label for="feMonthlyRevenueAverage">
          Qual a média mensal de vendas da sua empresa?
        </label>
        <d-form-input
          type="text"
          id="feMonthlyRevenueAverage"
          v-model="model.monthlyRevenueAverage"
          readonly
        />
      </d-col>
      <!-- companyAge -->
      <d-col sm="6" xl="4" class="form-group">
        <label for="feCompanyAge">Há quanto tempo a empresa está ativa?</label>
        <d-form-input
          type="text"
          id="feCompanyAge"
          v-model="model.companyAge"
          readonly
        />
      </d-col>
    </d-form-row>
    <d-form-row>
      <!-- SocialCapital -->
      <d-col
        sm="6"
        xl="4"
        class="form-group"
        v-if="model.company_details.social_capital"
      >
        <label for="feSocialCapital">Qual o capital social da empresa?</label>
        <d-form-input
          type="text"
          id="feSocialCapital"
          v-model="model.company_details.social_capital"
          readonly
        />
      </d-col>
      <!-- CompanyOpeningDate -->
      <d-col
        sm="6"
        xl="4"
        class="form-group"
        v-if="model.company_details.started_at"
      >
        <label for="feCompanyOpeningDate">
          Qual a data de abertura sua empresa?
        </label>
        <d-form-input
          type="text"
          id="feCompanyOpeningDate"
          v-model="model.company_details.started_at"
          readonly
        />
      </d-col>
      <!-- RegistrationStatus -->
      <d-col
        sm="6"
        xl="4"
        class="form-group"
        v-if="model.company_details.registration_status"
      >
        <label for="feRegistrationStatus">
          Qual a situação cadastral sua empresa?
        </label>
        <d-form-input
          type="text"
          id="feRegistrationStatus"
          v-model="model.company_details.registration_status"
          readonly
        />
      </d-col>
    </d-form-row>
    <!-- PrimaryCnae -->
    <d-form-row v-if="model.company_details.primary_cnae">
      <d-col sm="12" class="form-group">
        <label>Atividade Principal</label>
        <div class="border rounded bg-white">
          <table class="table table-striped custom-table mb-0">
            <tbody>
              <tr>
                <td class="pl-3 font-weight-bold text-primary cnae-code">
                  {{ model.company_details.primary_cnae.code }}
                </td>
                <td class="text-muted">
                  {{ model.company_details.primary_cnae.description }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </d-col>
    </d-form-row>
    <!-- SecondaryCnae -->
    <d-form-row
      v-if="
        model.company_details.secondary_cnaes &&
        model.company_details.secondary_cnaes.length
      "
    >
      <d-col sm="12" class="form-group">
        <label>Atividades Secundárias</label>
        <div class="border rounded bg-white">
          <table class="table table-striped custom-table my-0">
            <tbody>
              <tr
                v-for="(cnae, index) in model.company_details.secondary_cnaes"
                :key="index"
              >
                <td class="pl-3 font-weight-bold text-primary cnae-code">
                  {{ cnae.code }}
                </td>
                <td class="text-muted">
                  {{ cnae.description }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Email -->
      <d-col sm="6" class="form-group">
        <label for="feContactEmail">E-mail</label>
        <d-form-input
          type="email"
          v-model="model.email"
          id="feContactEmail"
          placeholder="E-mail"
          readonly
        />
      </d-col>
      <!-- Responsável -->
      <d-col sm="6" class="form-group">
        <label for="name">Responsável</label>
        <d-form-input
          type="text"
          id="name"
          label="Responsável"
          v-model="model.responsible"
          readonly
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Zipcode -->
      <d-col lg="3" sm="6" class="form-group">
        <label for="inputCEP">CEP</label>
        <masked-input
          type="text"
          class="text-left form-control"
          id="inputCEP"
          placeholder="00.000-000"
          :mask="[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
          :guide="false"
          v-model="model.zipcode"
          readonly
        />
      </d-col>

      <!-- Phone -->
      <d-col lg="3" sm="6" class="form-group">
        <label for="feTelefone">Telefone</label>
        <input-phone
          id="feTelefone"
          placeholder="Telefone"
          :model.sync="model.phone"
          readonly
        ></input-phone>
      </d-col>

      <!-- Contact by -->
      <d-col md="8" lg="6" xl="5" class="form-group">
        <label for="feInputProduct">Entrar em contato por</label>
        <div class="custom-container-checkbox">
          <d-checkbox
            v-for="(contact, index) in model.contact_by"
            :key="index"
            checked
            disabled
          >
            {{ contact }}
          </d-checkbox>
        </div>
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Street -->
      <d-col sm="12" xl="6" class="form-group">
        <label for="feInputStreet">Rua</label>
        <d-form-input
          type="text"
          id="feInputStreet"
          v-model="model.street"
          readonly
        />
      </d-col>

      <!-- Number -->
      <d-col sm="6" xl="3" class="form-group">
        <label for="feInputNumber">Número</label>
        <d-form-input
          type="text"
          id="feInputNumber"
          v-model="model.number"
          readonly
        />
      </d-col>

      <!-- District -->
      <d-col sm="6" xl="3" class="form-group">
        <label for="feInputDistrict">Bairro</label>
        <d-form-input
          type="text"
          id="feInputDistrict"
          v-model="model.district"
          readonly
        />
      </d-col>
    </d-form-row>
    <d-form-row>
      <!-- City -->
      <d-col sm="6" xl="4" class="form-group">
        <label for="feInputCidade">Cidade</label>
        <d-form-input
          type="text"
          id="feInputCidade"
          v-model="model.city"
          readonly
        />
      </d-col>

      <!-- State -->
      <d-col sm="6" xl="2" class="form-group">
        <label for="feInputState">Estado</label>
        <d-form-input
          type="text"
          id="feInputState"
          v-model="model.state"
          readonly
        />
      </d-col>

      <!-- Country -->
      <d-col sm="6" xl="3" class="form-group">
        <label for="feInputCountry">País</label>
        <d-form-input
          type="text"
          id="feInputCountry"
          v-model="model.country"
          readonly
        />
      </d-col>

      <!-- Kits -->
      <d-col sm="6" xl="3" class="form-group">
        <label for="feInputKits">Quantidades de Kits</label>
        <d-form-input
          type="text"
          id="feInputKits"
          v-model="model.kit_description"
          readonly
        />
      </d-col>
    </d-form-row>

    <!-- Google Map -->
    <div v-if="coordinates.lat && coordinates.lng" class="mb-3">
      <google-map :lat="coordinates.lat" :lng="coordinates.lng" />
    </div>

    <d-form-row style="align-items: center">
      <!-- Já Compra Riffel? -->
      <d-col xl="2" lg="3" md="6" sm="6" class="form-group custom-buy-from">
        <label for="feInputBuyFrom">Já Compra Riffel?</label>
        <div class="custom-container-checkbox buy-from">
          <d-checkbox :checked="model.buy_from !== null" disabled>
            Sim
          </d-checkbox>

          <d-checkbox :checked="model.buy_from === null" disabled>
            Não
          </d-checkbox>
        </div>
      </d-col>

      <!-- De quem? -->
      <d-col
        v-if="model.buy_from !== null"
        xl="4"
        lg="3"
        md="6"
        sm="6"
        class="form-group custom-buy-from"
      >
        <label for="feInputBuyFrom">De quem?</label>
        <d-form-input
          type="text"
          id="buyFrom"
          label="De quem?"
          v-model="model.buy_from"
          readonly
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Produtos -->
      <d-col sm="6" class="form-group custom-products">
        <label for="feInputProduct">Produtos</label>
        <d-checkbox
          v-for="(product, index) in model.product_interest"
          :key="index"
          checked
          disabled
        >
          {{ product }}
        </d-checkbox>
      </d-col>

      <!-- Segmentos -->
      <d-col sm="6" class="form-group pl-0 pl-sm-2 custom-segments">
        <label for="feInputProduct">Segmentos</label>
        <d-checkbox
          v-for="(segment, index) in model.segment"
          :key="index"
          checked
          disabled
        >
          {{ segment }}
        </d-checkbox>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import SelectState from '_shared/SelectState.vue';
import MaskedInput from 'vue-text-mask';
import InputPhone from '_shared/InputPhone.vue';
import Events from '_utils/events';
import GoogleMap from '_shared/GoogleMap.vue';
import GoogleApiService from '_services/common/googleApiService';
import { MODEL, _LOAD_MODEL_ } from './LeadModel';

export default {
  name: 'lead-form',
  components: {
    InputPhone,
    MaskedInput,
    SelectState,
    GoogleMap,
  },
  data() {
    return {
      model: { ...MODEL },
      coordinates: {
        lat: null,
        lng: null,
      },
    };
  },
  computed: {
    fullAddress() {
      return {
        street: this.model.street,
        number: this.model.number,
        district: this.model.district,
        city: this.model.city,
        state: this.model.state,
        country: this.model.country,
        zipcode: this.model.zipcode?.replace(/\D/g, ''),
      };
    },
  },
  methods: {
    ...mapActions(['activeAlert']),
    toggleLoading() {
      Events.$emit('loading', this.loading);
    },
    setCoordinates(lat, lng) {
      this.coordinates.lat = lat;
      this.coordinates.lng = lng;
    },
    getCoordinates() {
      GoogleApiService.getAddressCoordinates(this.fullAddress).then(
        response => {
          if (!response) return;
          this.setCoordinates(response.lat.toString(), response.lng.toString());
        }
      );
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = {
        ...newValue,
        company_details: {
          ...MODEL.company_details,
          ...(newValue.company_details || {}),
        },
      };

      this.getCoordinates();
    });
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
  },
};
</script>
<style lang="scss" scoped>
.custom-container-checkbox {
  display: flex;
  gap: 16px;
}

.custom-container-checkbox.buy-from {
  justify-content: left;
  gap: 8%;
}

.custom-buy-from {
  @media (min-width: 1115px) and (max-width: 1525px) {
    flex: 0 0 25% !important;
    max-width: 25% !important;
  }
}

.custom-products {
  @media (min-width: 576px) {
    border-right: 1px solid #cccccc !important;
  }
}

.custom-segments {
  @media (max-width: 575px) {
    padding-top: 8px;
    border-top: 1px solid #cccccc !important;
  }
}

.custom-table tbody tr:first-child td {
  border-top: 0 !important;
}

.cnae-code {
  width: 120px;
}

.custom-table td {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  vertical-align: middle;
}
</style>
